module.exports = __webpack_public_path__ + "static/media/icn-economies-impots.84f937b8.png";